<script setup lang="ts">
import type { FormKitFrameworkContext } from '@formkit/core'
import type { IconName } from '@webapp2/shared/components/icons/material-icon'
import { computed } from 'vue'

const props = defineProps<{
  context?: FormKitFrameworkContext & { icon?: IconName }
}>()
const disabled = computed(() => Boolean(props.context?.disabled))
const busy = computed(() => Boolean(props.context?.node.root.context?.state.loading))
</script>

<template>
  <Button :busy="busy" type="submit" :disabled="disabled" :class="context?.classes.input" :icon="props.context?.icon">
    <component :is="context?.slots.default"></component>
  </Button>
</template>
